import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_ZONE_WITHOUT_COMMUNITY } from "./apiRoutes";

const getPropertyZones = async () => await axiosAuth.get(`${PROPERTY_ZONE_WITHOUT_COMMUNITY}`);

const useGetPropertyZones = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-zones"],
    queryFn: () => getPropertyZones(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyZones;
